import Raven from '@Raven'
import { makeAutoObservable, observable } from 'mobx'
import StoreCountry from './StoreCountry'
import StoreAuth from './User/StoreAuth'
import StoreUser from './User/StoreUser'

class StoreFilter {
    showAll = true
    sortByOv = false
    showActiveLeg = false
    showCpv = true
    showApv = true
    showFsb = true
    swapTableView = false

    largeLevel = false
    showAllView = true
    isLargeGenealogyItems = false

    view = 'dashboard'
    initialFilter = false
    isChanged = false
    filterItem = 'items'
    resetItem = false
    located = false
    age = 0
    firstInit = false
    colSpan = 3

    currentSort = null

    resetGenealogyLevel = false
    serverFilterKeys = {
        hide_inactive_legs: this.showAll === false,
        name_in_left_column: this.swapTableView,
        show_active_leg: this.showActiveLeg,
        show_apv: this.showApv,
        show_cpv: this.showCpv,
        show_fsb: this.showFsb,
        sort_by_ov: this.sortByOv,
        view: this.view
    }

    get SortBy() {
        return {
            NO_SORT: 'noSort',
            SORT_OV: 'SortOV',
            HIDE_ZERO: 'HideZero',
            SORT_OV_AND_HIDE_ZERO: 'SortOVandHideZero'
        }
    }

    init(filterFromStore) {
        this.showAll = filterFromStore.showAll
        this.sortByOv = filterFromStore.sortByOv
        this.view = filterFromStore.view
        this.showActiveLeg = filterFromStore.showActiveLeg
    }

    iniDefault(defaultValue) {
        this.showAll = !defaultValue.hide_inactive_legs
        this.sortByOv = defaultValue.sort_by_ov
        this.view = defaultValue.view
        this.showActiveLeg = defaultValue.show_active_leg
        this.showFsb = defaultValue.show_fsb
        this.showApv = defaultValue.show_apv
        this.showCpv = defaultValue.show_cpv
        this.swapTableView = defaultValue.name_in_left_column
        this.save()
    }

    save() {
        this.selectItemsToRender()

        const filteredValues = {
            showAll: this.getShowAll,
            sortByOv: this.getSortByOv,
            view: this.getView,
            showActiveLeg: this.getShowActiveLeg,
            showFsb: this.showFsb,
            swapTableView: this.swapTableView,
            showApv: this.showApv,
            showCpv: this.showCpv
        }

        return this.saveFilter(filteredValues)
    }

    get getShowAll() {
        return this.showAll
    }

    setShowAll(value, setChange = true) {
        if (this.showAll !== value) {
            this.setIsChanged(true)
        }
        this.showAll = value
        if (setChange) {
            this.save()
        }
    }

    get getView() {
        return this.view
    }
    setView(value, setChange = true) {
        this.view = value
        if (setChange) {
            this.save()
        }
    }

    get getSortByOv() {
        return this.sortByOv
    }

    setSortByOv(value, setChange = true) {
        if (this.sortByOv !== value) {
            this.setIsChanged(true)
        }
        this.sortByOv = value
        if (setChange) {
            this.save()
        }
    }

    get getShowActiveLeg() {
        return this.showActiveLeg
    }

    setShowActiveLeg(value, setChange = true) {
        if (this.showActiveLeg !== value) {
            this.setIsChanged(true)
        }
        this.showActiveLeg = value
        if (setChange) {
            this.save()
        }
    }

    get getShowFsb() {
        return this.showFsb
    }

    setShowFsb(value, setChange = true) {
        if (this.showFsb !== value) {
            this.setIsChanged(true)
        }
        this.showFsb = value
        if (setChange) {
            this.save()
        }
    }

    getIsChanged() {
        return this.isChanged
    }

    setIsChanged(value) {
        this.firstInit === false ? (this.isChanged = value) : (this.firstInit = true)
    }

    get getResetItem() {
        return this.resetItem
    }

    setResetItem(value) {
        return (this.resetItem = value)
    }

    get getLocated() {
        return this.located
    }

    setLocated(value) {
        return (this.located = value)
    }

    get getAge() {
        return this.age
    }

    setAge(value) {
        this.age = value
    }

    getInitialFilter() {
        return this.initialFilter
    }

    setInitialFilter(value) {
        this.initialFilter = value
    }

    get getFilterItems() {
        return this.filterItem
    }

    setFilterItem(value) {
        this.filterItem = value
    }

    get getShowCpv() {
        return this.showCpv
    }

    setShowCpv(value, setChange = true) {
        if (this.showCpv !== value) {
            this.setIsChanged(true)
        }
        this.showCpv = value
        if (setChange) {
            this.save()
        }
    }

    get getShowApv() {
        return this.showApv
    }

    setShowApv(value, setChange = true) {
        if (this.showApv !== value) {
            this.setIsChanged(true)
        }
        this.showApv = value
        if (setChange) {
            this.save()
        }
    }

    get getSwapTableView() {
        return this.swapTableView
    }

    setSwapTableView(value, setChange = true) {
        if (this.swapTableView !== value) {
            this.setIsChanged(true)
        }
        this.swapTableView = value

        setTimeout(() => {
            if (setChange) {
                this.save()
            }
        }, 1000)
    }

    setValues(values) {
        Object.keys(values).map(v => {
            this[v] = values[v]
        })
    }

    selectItemsToRender() {
        if (this.getShowAll === true && this.getSortByOv === false) {
            this.currentSort = this.SortBy.NO_SORT
        } else if (this.getShowAll === false && this.getSortByOv === false) {
            this.currentSort = this.SortBy.HIDE_ZERO
        } else if (this.getShowAll === true && this.getSortByOv === true) {
            this.currentSort = this.SortBy.SORT_OV
        } else if (this.getShowAll === false && this.getSortByOv === true) {
            this.currentSort = this.SortBy.SORT_OV_AND_HIDE_ZERO
        }
    }

    saveFilter(filter) {
        const setItemUrl = `https://member-calls2.unicity.com/remoteStorage/data/genealogy-filters-${StoreAuth.id}`

        const headers = {
            'Content-Type': 'application/json'
        }

        return Raven.post(setItemUrl, filter, { headers: headers })
    }

    ColSpan(isMobile) {
        let defaultColSpan = this.colSpan

        let tempColSpan = 0
        if (this.showActiveLeg === true) {
            tempColSpan += 1
        }

        if (this.showApv === true && StoreCountry.ShouldShowApv(StoreUser.CustomerData().Country())) {
            tempColSpan += 1
        }

        if (isMobile) {
            if (this.showCpv === true && StoreCountry.ShouldShowCpv(StoreUser.CustomerData().Country())) {
                tempColSpan += 1
            }
            if (this.showFsb === true && StoreCountry.ShouldShowFsb(StoreUser.CustomerData().Country())) {
                tempColSpan += 1
            }
        }

        return defaultColSpan + tempColSpan
    }

    GetDot() {
        return Math.ceil(parseInt(this.age) / 10)
    }

    SetLargeLevel() {
        this.largeLevel = true
        this.setView('large-level')
    }

    constructor() {
        makeAutoObservable(this, {
            isChanged: observable
        })
    }
}

export const storeFilter = new StoreFilter()

// const privateStore = new PrivateStore()
